import classNames from "classnames";
import React, { useEffect } from "react";
import { ManageNonPartisanChartState } from '../hooks/use-manage-chart-hook';

const ManageNonPartisanChartGeneralData: React.FC<{
	state: ManageNonPartisanChartState;
	candidatesNamesChecked: boolean;
	setCandidatesNamesChecked: (e: any) => void;
}> = ({
	state: {
		form: { register, formState, watch, getValues, setValue },
		state,
	},
	candidatesNamesChecked,
	setCandidatesNamesChecked,
}) => {
		const showNamesWatch = watch("showCandidateNames");

		const resetRace = () => {
			if (getValues()?.races) {
				const resetedRaces = getValues().races.map(race => {
					const resetedRace = {
						...race,
						candidateNames: [],
						candidates: 0
					}
					return resetedRace;
				});

				setValue('races', resetedRaces);
			}
		}

		useEffect(() => {
			if (state?.name === 'Minnesota' || state?.name === 'Wisconsin') {
				setValue("showCandidateNames", true);
				resetRace();
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [state]);

		const toggleCandidateNames = () => {
			setValue("showCandidateNames", !showNamesWatch);
			resetRace();
		}

		return (
			<div className="grid grid-cols-2 gap-x-[80px] gap-y-8 mt-16">
				<div>
					<label
						htmlFor="municipality"
						className="font-medium tracking-widest uppercase"
					>
						Municipality name
					</label>
					<input
						{...register("municipality")}
						type="text"
						placeholder="Municipality Name"
						className={classNames(
							"w-full mt-2 px-4 py-3 border rounded-md border-primary-blue",
							{
								"border-red-500 focus:outline-red-500":
									formState?.errors?.municipality,
							}
						)}
					/>
					{formState?.errors?.municipality && (
						<div className="mt-1 text-sm text-red-500">
							{formState.errors.municipality.message}
						</div>
					)}
				</div>
				<div>
					<label
						htmlFor="county"
						className="font-medium tracking-widest uppercase"
					>
						County
					</label>
					<input
						{...register("county")}
						type="text"
						placeholder="County"
						className={classNames(
							"w-full mt-2 px-4 py-3 border rounded-md border-primary-blue",
							{
								"border-red-500 focus:outline-red-500": formState?.errors?.county,
							}
						)}
					/>
					{formState?.errors?.county && (
						<div className="mt-1 text-sm text-red-500">
							{formState.errors.county.message}
						</div>
					)}
				</div>
				<div>
					<label
						htmlFor="precinct"
						className="font-medium tracking-widest uppercase"
					>
						Precinct Number
					</label>
					<input
						{...register("precinct")}
						type="text"
						placeholder="Precinct Number"
						className={classNames(
							"w-full mt-2 px-4 py-3 border rounded-md border-primary-blue",
							{
								"border-red-500 focus:outline-red-500":
									formState?.errors?.precinct,
							}
						)}
					/>
					{formState?.errors?.precinct && (
						<div className="mt-1 text-sm text-red-500">
							{formState.errors.precinct.message}
						</div>
					)}
				</div>
				<div>
					<label
						htmlFor="electionDate"
						className="font-medium tracking-widest uppercase"
					>
						Date of election
					</label>
					<input
						{...register("electionDate")}
						type="date"
						placeholder="Select Date"
						className={classNames(
							"w-full mt-2 px-4 py-3 border rounded-md border-primary-blue",
							{
								"border-red-500 focus:outline-red-500":
									formState?.errors?.electionDate,
							}
						)}
					/>
					{formState?.errors?.electionDate && (
						<div className="mt-1 text-sm text-red-500">
							{formState.errors.electionDate.message}
						</div>
					)}
				</div>
				<div className="flex mb-8">
					<label className="flex justify-center">
						<input
							{...register("showCandidateNames")}
							type="checkbox"
							className="w-6 h-6 p-2 mr-2 border border-primary-blue"
							checked={getValues().showCandidateNames}
							onChange={toggleCandidateNames}
						/>
						<span className="h-6">Add Names for Candidates</span>
					</label>
				</div>
			</div>
		);
	};

export default ManageNonPartisanChartGeneralData;
